import { useState } from 'react'
import { Check, RefreshCw } from 'lucide-react'
declare const __NEXUS_BUILD_ID__: string

export default function WorkspaceUpdate({ beforeReload }: { beforeReload?: () => void }) {
  const [state, setState] = useState<'idle' | 'checking' | 'current' | 'error'>(() =>
    typeof __NEXUS_BUILD_ID__ === 'string' && new URLSearchParams(window.location.search).get('nexus_update') === __NEXUS_BUILD_ID__ ? 'current' : 'idle')
  const [message, setMessage] = useState('')
  const update = async () => {
    if (state === 'checking') return
    setState('checking'); setMessage('')
    const controller = new AbortController()
    const timer = window.setTimeout(() => controller.abort(), 15000)
    try {
      const response = await fetch(`/nexus-build.json?check=${Date.now()}`, { cache: 'no-store', signal: controller.signal })
      if (!response.ok) throw new Error('No se pudo buscar la actualización.')
      const version = await response.json()
      if (typeof version.build_id !== 'string' || !version.build_id) throw new Error('No se pudo verificar la versión.')
      const current = typeof __NEXUS_BUILD_ID__ === 'string' ? __NEXUS_BUILD_ID__ : 'development'
      if (version.build_id === current) { setState('current'); return }
      if (!window.dispatchEvent(new Event('nexus-before-update', { cancelable: true }))) throw new Error('Espera a que termine la operación de archivos y vuelve a pulsar Update.')
      beforeReload?.()
      if ('serviceWorker' in navigator) void navigator.serviceWorker.getRegistration().then(registration => registration?.update()).catch(() => {})
      const target = new URL(window.location.href)
      target.searchParams.set('nexus_update', version.build_id)
      window.location.replace(target.href)
    } catch (error) {
      setState('error'); setMessage(error instanceof Error ? error.message : 'No se pudo actualizar. Comprueba la conexión.')
    } finally { window.clearTimeout(timer) }
  }
  return <div className="workspace-update"><button type="button" className="parent-secondary-btn" onClick={() => void update()} disabled={state === 'checking'} title="Buscar actualización de Nexus">
    {state === 'current' ? <Check size={18} /> : <RefreshCw size={18} />} {state === 'checking' ? 'Checking…' : state === 'current' ? 'Up to date' : 'Update'}
  </button>{message && <span role="status">{message}</span>}</div>
}
